import { z } from "zod";

export const SendInvitationRequestSchema = z.object({
  email: z.string().email("Correo electrónico inválido"),
  poolId: z.string().min(1, "ID de la polla requerido"),
  invitedUserId: z.string().nullable().optional(),
});

export const AcceptInvitationRequestSchema = z.object({
  token: z.string().min(1, "Token de invitación requerido"),
});

export type SendInvitationRequestDTO = z.infer<typeof SendInvitationRequestSchema>;
export type AcceptInvitationRequestDTO = z.infer<typeof AcceptInvitationRequestSchema>;
